<template>
  <div class="billsInfoContent clearfix">
    <div class="jiazaiBox" v-if="billsInfo===null">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="billsInfo!==null" class="searchBox titleBox mb-4">
      <div class="box">
        <h5>
          出库单：{{billsInfo.no}}
          <span v-if="billsInfo.is_state==='2'" class="badge badge-secondary float-right d-none d-md-inline-block">已取消</span>
          <span v-if="billsInfo.is_state!=='2' && billsInfo.remaining_sum*1!==0" class="badge badge-danger float-right d-none d-md-inline-block">待付款</span>
          <span v-if="billsInfo.is_state!=='2' && billsInfo.remaining_sum*1===0" class="badge badge-primary float-right d-none d-md-inline-block">已付款</span>
          <span v-if="billsInfo.is_state!=='2'" class="badge badge-primary float-right mr-2 d-none d-md-inline-block">已发货</span>
        </h5>
        <h5 class="d-block d-md-none">
          <span v-if="billsInfo.is_state==='2'" class="badge badge-secondary">已取消</span>
          <span v-if="billsInfo.is_state!=='2' && billsInfo.remaining_sum*1!==0" class="badge badge-danger">待付款</span>
          <span v-if="billsInfo.is_state!=='2' && billsInfo.remaining_sum*1===0" class="badge badge-primary">已付款</span>
          <span v-if="billsInfo.is_state!=='2'" class="badge badge-primary mr-2">已发货</span>
        </h5>
        <p class="content"><small>— 内部销售下单</small></p>
        <hr style="border-color:rgba(0,0,0,0.1);">
        <div class="row">
          <div class="col-12 col-md-6">
            <span class="content">订单金额：</span> {{billsInfo.currencyType==='1'?'￥':''}}{{billsInfo.currencyType==='2'?'$':''}}{{billsInfo.total_price}}
          </div>
          <div class="col-12 col-md-6">
            <span class="content">创建时间：</span> {{billsInfo.bill_date_str}}
          </div>
          <div class="col-12 col-md-6">
            <span class="content">付款时间：</span> {{billsInfo.remaining_sum*1!==0?'付款中':billsInfo.payTimeStr}}
          </div>
          <div class="col-12 col-md-6">
            <span class="content">付款账户：</span> {{billsInfo.remaining_sum*1!==0?'付款中':billsInfo.proceeds_id_title}}
          </div>
          <div class="col-12">
            <span class="content">订单说明：</span> {{billsInfo.remark_content?billsInfo.remark_content:'暂无备注...'}}
          </div>
        </div>
      </div>
    </div>
    <div v-if="billsInfo!==null" class="threeBox yuanjiao mb-4">
      <h5>订单内容</h5>
      <p class="content"><small>— 包含订单内所有的商品列表</small></p>
      <hr style="border-color:rgba(0,0,0,0.1);">
      <div class="table-responsive">
        <table class="table table-bordered orderInfo">
          <thead>
          <tr class="bg-light">
            <td>商品</td>
            <td>价格</td>
            <td>操作</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(app,index) in goodsArr" :key="index">
            <td>
              <span class="content">{{index+1}}.</span> <span class="content" v-if="app.is_state==='2'">赠送 / </span>{{app.name}} × {{app.num}}
            </td>
            <td class="text-primary">
              {{billsInfo.currencyType==='1'?'￥':''}}{{billsInfo.currencyType==='2'?'$':''}}{{app.price_tax_total}}
            </td>
            <td class="bg-light">
              <span @click="showDetailFun(app.id)" class="cursor">查看</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="billsInfo!==null" class="threeBox yuanjiao mb-4">
      <h5>发货明细</h5>
      <p class="content"><small>— 订单内所有发货明细</small></p>
      <hr style="border-color:rgba(0,0,0,0.1);">
      <div v-for="(apps,indexs) in goodsArr" :key="indexs" class="mingxiBox">
        <p class="chanpinming"><small>{{indexs+1}}：{{apps.name}}</small></p>
        <div v-if="apps.detailInfo.data.is_serial===1" class="ruanjianBox">
          <table class="table table-bordered">
            <thead>
            <tr class="bg-light">
              <td>激活码</td>
              <td>操作</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(app,index) in apps.detailInfo.data.serialArr" :key="index">
              <td><span v-if="app.is_del==='1'" class="text-danger">已退 # </span>{{app.serial_number}}</td>
              <td class="cursor bg-light" @click="copyToClipboard(app.serial_number)">复制</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="apps.detailInfo.data.is_serial===0" class="shebeiBox">
          <div>
            <span>{{apps.detailInfo.data.num}}</span>
            <small class="content">已发</small>
          </div>
          <div class="ml-3" v-if="apps.detailInfo.data.tui!==0">
            <span>{{apps.detailInfo.data.tui}}</span>
            <small class="content">已退</small>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isShowDetailInfoBox" class="showDetailBox" @click.self="hideShowDetailInfoBoxFun()">
      <div class="box">
        <div class="topBox">
          <h3 class="m-0">详情</h3>
          <i @click="hideShowDetailInfoBoxFun()" class="iconfont icon-guanbi close float-right cursor"></i>
        </div>
        <div v-if="detailInfo.is_serial===1" class="ruanjianBox">
          <table class="table table-bordered">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">激活码</th>
              <th scope="col">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(app,index) in detailInfo.serialArr" :key="index">
              <th scope="row">{{index+1}}</th>
              <td><span v-if="app.is_del==='1'" class="text-danger">已退 # </span>{{app.serial_number}}</td>
              <td class="cursor" @click="copyToClipboard(app.serial_number)">复制</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="detailInfo.is_serial===0" class="shebeiBox">
          <div>
            <span>{{detailInfo.num}}</span>
            已发
          </div>
          <div class="ml-3" v-if="detailInfo.tui!==0">
            <span>{{detailInfo.tui}}</span>
            已退
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import resultcommons from '../../util/resultcommons';
  import commons from '../../util/commons';
  // import { EventBus } from '@/util/eventBus';
  import generalMix from '@/util/mix/general';

  export default {
    name: 'billsInfoContent',
    props:['parameter'],
    mixins: [generalMix],
    data () {
      return {
        billsInfo:null,
        goodsArr:[],
        id:'',
        isShowDetailInfoBox:false,
        detailInfo:null
      }
    },
    methods:{
      hideShowDetailInfoBoxFun() {
        this.isShowDetailInfoBox = false;
        this.detailInfo = null;
      },
      showDetailFun(id) {
        resultcommons.apiOrderdetailinfo(this,{token: id}).then(app=>{
          if(app.state === 200){
            this.detailInfo = app.data;
            this.isShowDetailInfoBox = true;
          }else{
            this.$message.showMsgBox({
              type: 'success',
              content: app.message
            });
          }
        });
      },
      // 显示详情
      copyToClipboard(text) {
        commons.copyToClipboard(text);
        this.$message.showMsgBox({
          type: 'success',
          content: '复制成功'
        });
      }
    },
    components: {
    },
    created() {
      this.id = this.parameter.token;
      // 标签
      resultcommons.apiBillsinfo(this,{token:this.id}).then(app=>{
        if(app.state === 200){
          this.billsInfo = app.data.billsInfo;
          this.goodsArr = app.data.goodsArr;
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: app.message
          });
        }
      });
    },
    mounted() {
    },
    destroyed() {
    }
  }
</script>

<style scoped lang='less'>

  .billsInfoContent {
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    background: #F5F5F7;
    color: #000000;
    width: 60vw;
    height: 100%;
    padding-bottom: 0;
    overflow-y: auto;
    div.showDetailBox{
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: rgba(0,0,0,0.4);
      display: flex;
      justify-content: center;
      align-items: center;
      div.box{
        width: 60vw;
        height: 80vh;
        background: #FFFFFF;
        border-radius: 5px;
        padding: 20px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        div.topBox{
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          i.close{
            font-size: 32px;
          }
        }
      }
    }
    .titleBox {
      color: #000000;
      margin-bottom: 30px;
      p {
        margin: 0;
        //color: rgba(255, 255, 255, 0.5);
      }
      h2{
        font-size: 22px;
      }
    }
    div.jiazaiBox{
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      /*box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);*/
      background: #FFFFFF;
      min-height: 100vh;
      .spinner-border{
        width: 3rem;
        height: 3rem;
      }
    }
    div.searchBox{
      display: flex;
      border-radius: 5px;
      padding: 20px;
      background: #FFFFFF;
      div.box{
        flex: 1;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        div.col-12{
          line-height: 2em;
        }
      }
    }
    div.threeBox{
      padding: 20px;
      background: #FFFFFF;
      // 订单内容
      table.orderInfo{
        margin: 0;
        tr{
          td,th{
            white-space: nowrap;
            &:nth-child(2){
              width: 120px;
            }
            &:last-child{
              width: 100px;
              text-align: center;
            }
          }
        }
      }
      div.mingxiBox{
        p.chanpinming{
        }
        div.ruanjianBox{
          flex: 1;
          overflow-y: auto;
          table{
            table-layout: fixed;
            tr{
              td,th{
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                &:last-child{
                  width: 100px;
                  text-align: center;
                }
              }
            }
          }
        }
        div.shebeiBox{
          flex: 1;
          background: #F5F5F7;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 15px;
          border: 1px solid #DEE2E6;
          div{
            display: flex;
            flex: 1;
            align-items: center;
            flex-direction: column;
            background: #FFFFFF;
            padding: 10px 0;
            span{
              font-size: 18px;
            }
          }
        }
      }

    }
  }

  @media (max-width: 1200px) {
    .billsInfoContent{
      width: 70vw;
    }
  }

  @media (max-width: 992px) {
    .billsInfoContent{
      width: 90vw;
    }
  }

  @media (max-width: 776px) {
    .billsInfoContent{
      width: 90vw;
      padding: 15px;
      div.searchBox{
        padding: 15px;
      }
      div.threeBox{
        padding: 15px;
      }
    }
  }

  @media (max-width: 575px) {
    .billsInfoContent{
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/order/Billsinfo.vue